var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" You have been logged out. Click Login on the menu bar to log in again ")])
}
var staticRenderFns = []

export { render, staticRenderFns }